
import Vue from 'vue';

import { mapState } from 'pinia';
import { useStore as useProductStore } from '@/stores/product';
import { useStore as useNotificationStore } from '@/stores/notification';
import PipelineValidationNotification from './PipelineValidationNotification.vue';
import CommercialRemarkNotification from './CommercialRemarkNotification.vue';
import { PipelineNotificationType } from './typings/PipelineNotificationType';

export default Vue.extend({
  name: 'PipelineValidationMonitor',

  components: {
    PipelineValidationNotification,
    CommercialRemarkNotification,
  },

  computed: {
    ...mapState(useProductStore, ['selectedPrintPosition']),
    ...mapState(useNotificationStore, ['notificationsForBell']),

    pipeline(): PipelineNotificationType[] {
      return this.notificationsForBell.filter(
        (x) =>
          x.printPositionId === this.selectedPrintPosition.id &&
          x.validatorName !== 'smallDetails' &&
          x.validatorName !== 'outOfBoundaries' &&
          (x.validatorColor === 'Red' || x.validatorColor === 'Orange')
      );
    },
  },
});
